export const NAVIGATION = {
    AUTH: 'auth',
    DASHBOARD: '/dashboard',
};
